

















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import draggable from "vuedraggable";
import { days_of_week } from "@/config/dailySchedule/schedule-by-day.config.json";
import { ITimetable, ITimetableBlob } from "@/@types/timetable/timetable";
@Component({
  components: { draggable },
})
export default class DailyScheduleDemo extends Vue {
  @Prop({ type: Array, default: () => [] }) timetables!: ITimetable[];
  @Prop({ type: Array, default: () => [] })
  timetablesDraggable!: ITimetableBlob[];
  @Prop({ type: String, default: null }) lang!: string;

  daysWeek = days_of_week;
  enabled = true;
  dragging = false;
  URL = URL;
  fullScreenImage: Blob | null = null;

  checkMove(e: any): void {
    window.console.log(e.draggedContext.futureIndex);
  }

  // @Watch("timetablesDraggable", { deep: true })
  updateTimetablesDraggable(): void {
    this.dragging = false;
    for (let i = 0; i < days_of_week.length; i++) {
      this.timetablesDraggable[i].day = days_of_week[i];
    }
    this.$emit("updateTimetablesDraggable", this.timetablesDraggable);
  }
}
